import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { withStyles } from '@material-ui/core';
import { locationAvailabilityInitQuery } from './queries';
import styles from './styles';
import ViewAvailabilityComponent from '../../../components/Global/Location/Common/components/StepAvailability';
import { Dashboard } from '../../../layouts';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {}

const ViewLocationAvailability = (_props: Props): React.ReactElement => {
  const [locationId, setLocationId] = useState<string>('');
  const [organisationId, setOrganisationId] = useState<string>('');

  const { data } = useQuery(locationAvailabilityInitQuery, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (data?.locations?.[0]) {
      setLocationId(data.locations[0].id);
      setOrganisationId(data.locations[0].organisation_id);
    }
  }, [data]);

  if (!locationId) {
    return <Dashboard title="Availability Management"><div /></Dashboard>;
  }

  return (
    <Dashboard title="Availability Management">
      <ViewAvailabilityComponent classes={{}} location_id={locationId} organisation_id={organisationId} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ViewLocationAvailability));
